var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrossIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3497 14C11.9372 14 11.5246 13.848 11.1989 13.5223L0.472276 2.77394C-0.157425 2.14424 -0.157425 1.10198 0.472276 0.472276C1.10198 -0.157425 2.14424 -0.157425 2.77394 0.472276L13.5006 11.2206C14.1303 11.8503 14.1303 12.8926 13.5006 13.5223C13.1749 13.848 12.7623 14 12.3497 14Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.62311 13.9993C1.21055 13.9993 0.797984 13.8473 0.472276 13.5216C-0.157425 12.8919 -0.157425 11.8496 0.472276 11.2199L11.1989 0.493272C11.8286 -0.136429 12.8709 -0.136429 13.5006 0.493272C14.1303 1.12297 14.1303 2.16524 13.5006 2.79494L2.77394 13.5216C2.44824 13.8473 2.03567 13.9993 1.62311 13.9993Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/CrossIcon.3698fc668b45b6abf2abbe0c51f83586.svg";
export { ForwardRef as ReactComponent };